
(function () {
  'use strict';

  var CUT_ALLOWANCE_MM = 100;
  var EPS = 0.01;

  function positiveMod(value, modulus) {
    if (!modulus) return 0;
    var result = ((value % modulus) + modulus) % modulus;
    if (Math.abs(result) < EPS || Math.abs(result - modulus) < EPS) return 0;
    return result;
  }

  function numberFromMatch(text, regex) {
    var match = String(text || '').match(regex);
    if (!match) return null;
    var value = parseFloat(match[1]);
    return Number.isFinite(value) ? value : null;
  }

  function parseProductSpecs(description) {
    var text = String(description || '').replace(/\s+/g, ' ').trim();
    var width = numberFromMatch(text, /Width\s*\(mm\)\s*:\s*([0-9.]+)/i);
    var repeatMatch = text.match(/Repeat\s*\(mm\)\s*:\s*([0-9.]+|N\/A)/i);
    var repeat = repeatMatch && !/N\/A/i.test(repeatMatch[1]) ? parseFloat(repeatMatch[1]) : null;
    var styleMatch = text.match(/Style\s*:\s*(.*?)(?=\s+Composition\s*:|\s+Weight\s*\(|\s+Process\s*:|\s+Roll\s+Length\s*:|$)/i);
    var style = styleMatch ? styleMatch[1].trim() : '';
    var rollLength = numberFromMatch(text, /Roll\s+Length\s*:\s*([0-9.]+)/i) || 10;
    var panelMatch = text.match(/Per\s+Panel\s*\(\s*([0-9.]+)\s*mm\s+total\s*\)/i);

    return {
      width: width,
      repeat: repeat,
      repeatLabel: repeatMatch ? repeatMatch[1] : '',
      style: style,
      rollLength: rollLength,
      panelTotal: panelMatch ? parseFloat(panelMatch[1]) : null,
      isPanel: Boolean(panelMatch || (repeatMatch && /N\/A/i.test(repeatMatch[1])))
    };
  }

  function normaliseMatch(style) {
    var value = String(style || '').toLowerCase();
    if (value.indexOf('free') !== -1) return 'free';
    if (value.indexOf('quarter') !== -1) return 'quarter';
    if (value.indexOf('3/4') !== -1 || value.indexOf('three quarter') !== -1) return 'threequarter';
    if (value.indexOf('half') !== -1) return 'half';
    return 'straight';
  }

  function matchOffset(match) {
    if (match === 'free') return null;
    if (match === 'quarter') return 0.25;
    if (match === 'threequarter') return 0.75;
    if (match === 'half') return 0.5;
    return 0;
  }

  function formatMatch(style, match) {
    if (/straight\s*match\s*\/\s*half/i.test(style || '')) {
      return 'Straight / half drop (half-drop allowance used)';
    }
    if (match === 'free') return 'Free match';
    if (match === 'quarter') return 'Quarter drop';
    if (match === 'threequarter') return 'Three-quarter drop';
    if (match === 'half') return 'Half drop';
    return 'Straight match';
  }

  function metres(mm) {
    return (mm / 1000).toFixed(2).replace(/\.00$/, '') + 'm';
  }

  function createWall(root, heightValue) {
    var walls = root.querySelector('[data-calc-walls]');
    if (!walls) return;

    var wall = document.createElement('div');
    wall.className = 'twc-calc__wall';
    wall.setAttribute('data-calc-wall', '');
    wall.innerHTML =
      '<div class="twc-calc__wall-head">' +
        '<strong data-calc-wall-title>Wall</strong>' +
        '<button type="button" class="twc-calc__remove" data-calc-remove>Remove</button>' +
      '</div>' +
      '<div class="twc-calc__wall-fields">' +
        '<label class="twc-calc__field">' +
          '<span class="twc-calc__field-label">Wall width <span>metres</span></span>' +
          '<input type="number" min="0.1" step="0.01" inputmode="decimal" placeholder="e.g. 4.20" data-calc-wall-width>' +
        '</label>' +
        '<label class="twc-calc__field">' +
          '<span class="twc-calc__field-label">Wall height <span>metres</span></span>' +
          '<input type="number" min="0.1" step="0.01" inputmode="decimal" placeholder="e.g. 2.40" data-calc-wall-height>' +
        '</label>' +
      '</div>';

    if (heightValue) wall.querySelector('[data-calc-wall-height]').value = heightValue;
    walls.appendChild(wall);
    renumberWalls(root);
  }

  function renumberWalls(root) {
    var walls = Array.prototype.slice.call(root.querySelectorAll('[data-calc-wall]'));
    walls.forEach(function (wall, index) {
      var title = wall.querySelector('[data-calc-wall-title]');
      var remove = wall.querySelector('[data-calc-remove]');
      if (title) title.textContent = 'Wall ' + (index + 1);
      if (remove) remove.hidden = walls.length === 1;
    });
  }

  function setError(root, message, allowHtml) {
    var error = root.querySelector('[data-calc-error]');
    if (!error) return;
    if (!message) {
      error.hidden = true;
      error.textContent = '';
      return;
    }
    if (allowHtml) error.innerHTML = message;
    else error.textContent = message;
    error.hidden = false;
  }

  function clearResult(root) {
    var result = root.querySelector('[data-calc-result]');
    if (result) result.hidden = true;
  }

  function getPageSpecs(root) {
    var widthEl = root.querySelector('[data-calc-roll-width]');
    var repeatEl = root.querySelector('[data-calc-repeat]');
    var matchEl = root.querySelector('[data-calc-match]');

    var width = widthEl ? parseFloat(widthEl.value) : null;
    var match = matchEl ? matchEl.value : 'straight';
    var repeat = repeatEl ? parseFloat(repeatEl.value) : null;

    return {
      width: width,
      repeat: Number.isFinite(repeat) ? repeat : null,
      style: match,
      match: match,
      rollLength: 10,
      isPanel: false
    };
  }

  function getSpecs(root) {
    if (root.getAttribute('data-context') === 'product') {
      var script = root.querySelector('[data-calc-product-data]');
      if (!script) return null;
      try {
        var data = JSON.parse(script.textContent);
        var specs = parseProductSpecs(data.description || '');
        specs.title = data.title || '';
        specs.match = normaliseMatch(specs.style);
        return specs;
      } catch (error) {
        return null;
      }
    }
    return getPageSpecs(root);
  }

  function getWalls(root) {
    var walls = [];
    var invalid = false;

    Array.prototype.slice.call(root.querySelectorAll('[data-calc-wall]')).forEach(function (wall, index) {
      var width = parseFloat((wall.querySelector('[data-calc-wall-width]') || {}).value);
      var height = parseFloat((wall.querySelector('[data-calc-wall-height]') || {}).value);
      if (!Number.isFinite(width) || !Number.isFinite(height) || width <= 0 || height <= 0) {
        invalid = true;
        return;
      }
      walls.push({ index: index + 1, width: width, height: height });
    });

    return invalid ? null : walls;
  }

  function simulate(walls, specs) {
    if (!specs || !Number.isFinite(specs.width) || specs.width <= 0) {
      throw new Error('Wallpaper width is missing or invalid.');
    }

    var match = specs.match || normaliseMatch(specs.style);
    var repeat = specs.repeat;

    if (match !== 'free' && (!Number.isFinite(repeat) || repeat <= 0)) {
      throw new Error('A pattern repeat is required for this wallpaper.');
    }

    var rollLengthMm = (Number.isFinite(specs.rollLength) ? specs.rollLength : 10) * 1000;
    var offset = matchOffset(match);
    var jobs = [];
    var wallBreakdown = [];
    var totalArea = 0;

    walls.forEach(function (wall) {
      var drops = Math.ceil((wall.width * 1000) / specs.width);
      wallBreakdown.push({
        index: wall.index,
        width: wall.width,
        height: wall.height,
        drops: drops
      });
      totalArea += wall.width * wall.height;

      for (var i = 0; i < drops; i += 1) {
        jobs.push({
          wallIndex: wall.index,
          cutLength: (wall.height * 1000) + CUT_ALLOWANCE_MM
        });
      }
    });

    var rolls = [];
    var current = { used: 0, drops: 0, alignmentWaste: 0, wallDrops: {} };
    var sequenceIndex = 0;

    function desiredPhaseFor(index) {
      if (offset === null) return null;
      return positiveMod(index * offset * repeat, repeat);
    }

    function alignmentFor(used, desiredPhase) {
      if (desiredPhase === null) return 0;
      return positiveMod(desiredPhase - positiveMod(used, repeat), repeat);
    }

    function pushCurrent() {
      if (!current.drops) return;
      current.remaining = Math.max(0, rollLengthMm - current.used);
      current.fullRepeatsRemaining = Number.isFinite(repeat) && repeat > 0
        ? Math.floor((current.remaining + EPS) / repeat)
        : null;
      rolls.push(current);
    }

    jobs.forEach(function (job) {
      var desiredPhase = desiredPhaseFor(sequenceIndex);
      var alignment = alignmentFor(current.used, desiredPhase);

      if ((current.used + alignment + job.cutLength) > (rollLengthMm + EPS)) {
        pushCurrent();
        current = { used: 0, drops: 0, alignmentWaste: 0, wallDrops: {} };
        alignment = alignmentFor(0, desiredPhase);
      }

      if ((alignment + job.cutLength) > (rollLengthMm + EPS)) {
        throw new Error('One wall is taller than a usable 10m roll once matching and cutting allowance are included.');
      }

      current.used += alignment + job.cutLength;
      current.alignmentWaste += alignment;
      current.drops += 1;
      current.wallDrops[job.wallIndex] = (current.wallDrops[job.wallIndex] || 0) + 1;
      sequenceIndex += 1;
    });

    pushCurrent();

    return {
      rolls: rolls,
      totalDrops: jobs.length,
      totalArea: totalArea,
      wallBreakdown: wallBreakdown,
      match: match,
      matchLabel: formatMatch(specs.style, match),
      cuttingAllowance: CUT_ALLOWANCE_MM,
      rollLengthMm: rollLengthMm,
      width: specs.width,
      repeat: repeat
    };
  }

  function renderProductSpecs(root, specs) {
    var summary = root.querySelector('[data-calc-spec-summary]');
    if (summary && specs) {
      var repeatText = Number.isFinite(specs.repeat) ? specs.repeat + 'mm repeat' : 'panel layout';
      summary.textContent =
        (specs.width / 10).toFixed(1).replace(/\.0$/, '') + 'cm roll · ' +
        repeatText + ' · ' +
        formatMatch(specs.style, specs.match);
    }
  }

  function renderResult(root, calculation, specs) {
    var result = root.querySelector('[data-calc-result]');
    if (!result) return;

    var rollCount = calculation.rolls.length;
    var rollNumber = root.querySelector('[data-calc-roll-count]');
    var rollWord = root.querySelector('[data-calc-roll-word]');
    var copy = root.querySelector('[data-calc-result-copy]');
    var details = root.querySelector('[data-calc-details-content]');
    var useButton = root.querySelector('[data-calc-use]');

    if (rollNumber) rollNumber.textContent = rollCount;
    if (rollWord) rollWord.textContent = rollCount === 1 ? 'roll' : 'rolls';
    if (copy) {
      copy.textContent =
        'Based on ' + calculation.totalDrops + ' full drops across ' +
        calculation.wallBreakdown.length + (calculation.wallBreakdown.length === 1 ? ' wall.' : ' walls.');
    }

    if (useButton) {
      useButton.textContent = 'Use ' + rollCount + (rollCount === 1 ? ' roll' : ' rolls');
      useButton.setAttribute('data-rolls', String(rollCount));
    }

    if (details) {
      var wallItems = calculation.wallBreakdown.map(function (wall) {
        return '<li><strong>Wall ' + wall.index + ':</strong> ' +
          wall.width.toFixed(2) + 'm × ' + wall.height.toFixed(2) + 'm = ' +
          wall.drops + (wall.drops === 1 ? ' drop' : ' drops') + '</li>';
      }).join('');

      var rollItems = calculation.rolls.map(function (roll, index) {
        var extra = '';
        if (roll.fullRepeatsRemaining !== null) {
          extra = ' · ' + roll.fullRepeatsRemaining + ' full ' +
            (roll.fullRepeatsRemaining === 1 ? 'repeat' : 'repeats') + ' left';
        }
        return '<li><strong>Roll ' + (index + 1) + ':</strong> ' +
          roll.drops + (roll.drops === 1 ? ' drop' : ' drops') +
          ' · ' + metres(roll.remaining) + ' remaining' + extra + '</li>';
      }).join('');

      var repeatText = Number.isFinite(calculation.repeat)
        ? calculation.repeat + 'mm'
        : 'not required';

      details.innerHTML =
        '<p><strong>Wallpaper:</strong> ' +
          (calculation.width / 10).toFixed(1).replace(/\.0$/, '') + 'cm wide · ' +
          repeatText + ' repeat · ' + calculation.matchLabel + '</p>' +
        '<p><strong>Cutting allowance:</strong> 10cm is allowed on every drop (5cm top and bottom).</p>' +
        '<p><strong>Pattern logic:</strong> Each drop is positioned on the roll at the correct pattern phase. ' +
          'Any usable length left on a roll is carried forward before another roll is opened.</p>' +
        '<p><strong>No blanket 10% waste is added.</strong> Pattern alignment and the cutting allowance are already included in the roll simulation.</p>' +
        '<p><strong>Walls:</strong></p><ul>' + wallItems + '</ul>' +
        '<p><strong>Roll usage:</strong></p><ul>' + rollItems + '</ul>';
    }

    result.hidden = false;
    result.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  function configurePageRepeat(root) {
    var matchEl = root.querySelector('[data-calc-match]');
    var repeatWrap = root.querySelector('[data-calc-repeat-wrap]');
    var repeatInput = root.querySelector('[data-calc-repeat]');
    if (!matchEl || !repeatWrap || !repeatInput) return;

    function sync() {
      var isFree = matchEl.value === 'free';
      repeatWrap.hidden = isFree;
      repeatInput.disabled = isFree;
      if (isFree) repeatInput.value = '';
    }

    matchEl.addEventListener('change', function () {
      sync();
      clearResult(root);
      setError(root, '');
    });
    sync();
  }

  function initCalculator(root) {
    if (!root || root.getAttribute('data-calc-ready') === 'true') return;
    root.setAttribute('data-calc-ready', 'true');

    createWall(root, '');
    configurePageRepeat(root);

    var specs = getSpecs(root);
    if (specs) renderProductSpecs(root, specs);

    if (root.getAttribute('data-context') === 'product') {
      if (!specs) {
        setError(root, 'We could not load this wallpaper’s technical details. Please use the full wallpaper calculator or contact us.', false);
        var formMissing = root.querySelector('[data-calc-form]');
        if (formMissing) formMissing.hidden = true;
      } else if (specs.isPanel) {
        setError(
          root,
          '<strong>This design uses a multi-panel sequence.</strong><br>Because panel layouts do not use a standard vertical repeat, an automatic roll estimate could be misleading. <a href="/pages/contact">Send us your wall measurements</a> and we will calculate it for you.',
          true
        );
        var formPanel = root.querySelector('[data-calc-form]');
        if (formPanel) formPanel.hidden = true;
      }
    }

    root.addEventListener('click', function (event) {
      var add = event.target.closest('[data-calc-add]');
      if (add) {
        event.preventDefault();
        var walls = root.querySelectorAll('[data-calc-wall]');
        var last = walls.length ? walls[walls.length - 1] : null;
        var lastHeight = last && last.querySelector('[data-calc-wall-height]')
          ? last.querySelector('[data-calc-wall-height]').value
          : '';
        createWall(root, lastHeight);
        clearResult(root);
        return;
      }

      var remove = event.target.closest('[data-calc-remove]');
      if (remove) {
        event.preventDefault();
        var wall = remove.closest('[data-calc-wall]');
        if (wall) wall.remove();
        renumberWalls(root);
        clearResult(root);
        return;
      }

      var calculate = event.target.closest('[data-calc-calculate]');
      if (calculate) {
        event.preventDefault();
        setError(root, '');

        var currentSpecs = getSpecs(root);
        if (!currentSpecs) {
          setError(root, 'Please check the wallpaper details and try again.');
          return;
        }

        if (currentSpecs.isPanel) {
          setError(root, 'This panel design needs a manual quantity check. Please contact us with your measurements.');
          return;
        }

        var wallsData = getWalls(root);
        if (!wallsData || !wallsData.length) {
          setError(root, 'Please enter a valid width and height for every wall.');
          return;
        }

        if (root.getAttribute('data-context') === 'page') {
          currentSpecs.match = (root.querySelector('[data-calc-match]') || {}).value || 'straight';
          if (currentSpecs.match !== 'free' && (!Number.isFinite(currentSpecs.repeat) || currentSpecs.repeat <= 0)) {
            setError(root, 'Please enter the wallpaper pattern repeat in millimetres.');
            return;
          }
        }

        try {
          var calculation = simulate(wallsData, currentSpecs);
          renderResult(root, calculation, currentSpecs);
        } catch (error) {
          setError(root, error && error.message ? error.message : 'We could not calculate that combination. Please check your measurements.');
        }
        return;
      }

      var use = event.target.closest('[data-calc-use]');
      if (use) {
        event.preventDefault();
        var rolls = parseInt(use.getAttribute('data-rolls'), 10);
        var targetId = root.getAttribute('data-quantity-target');
        var quantity = targetId ? document.getElementById(targetId) : null;
        if (quantity && Number.isFinite(rolls)) {
          quantity.value = rolls;
          quantity.dispatchEvent(new Event('input', { bubbles: true }));
          quantity.dispatchEvent(new Event('change', { bubbles: true }));
        }

        var dialog = root.closest('dialog');
        if (dialog && typeof dialog.close === 'function') dialog.close();

        if (quantity) {
          window.setTimeout(function () {
            quantity.focus({ preventScroll: true });
          }, 50);
        }
      }
    });

    root.addEventListener('input', function (event) {
      if (event.target.matches('input, select')) {
        clearResult(root);
        setError(root, '');
      }
    });
  }

  function initAll(scope) {
    var container = scope || document;
    Array.prototype.slice.call(container.querySelectorAll('[data-twc-calculator]')).forEach(initCalculator);
  }

  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-twc-calc-open]');
    if (opener) {
      event.preventDefault();
      var dialogId = opener.getAttribute('data-twc-calc-open');
      var dialog = document.getElementById(dialogId);
      if (!dialog) return;
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', 'open');

      window.setTimeout(function () {
        var first = dialog.querySelector('[data-calc-wall-width]');
        if (first) first.focus();
      }, 60);
      return;
    }

    var close = event.target.closest('[data-twc-calc-close]');
    if (close) {
      event.preventDefault();
      var closeDialog = close.closest('dialog');
      if (closeDialog && typeof closeDialog.close === 'function') closeDialog.close();
      else if (closeDialog) closeDialog.removeAttribute('open');
    }
  });

  document.addEventListener('click', function (event) {
    if (event.target && event.target.matches('dialog.twc-calc-dialog')) {
      if (typeof event.target.close === 'function') event.target.close();
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
